import Headspace from 'headspace';

jQuery(document).ready(function ($) {
    /* Custom JS
	   Feel free to break into separate files if individual functions grow to excessive sizes.
	   Gulp will concatenate and minify separate files automatically.
	*/

    Headspace(document.getElementById('header'), {
        tolerance: 8, // default: 8
        showAtBottom: true,
    });
});



// WEBPACK FOOTER //
// ./src/js/scripts.js